import { dynamicLoader } from '~/utils';

export const ProjectsPage = dynamicLoader({
  name: 'ProjectsPage',
  importFunc: () => import('./projects'),
});